import { useTranslation } from 'react-i18next';
import React from 'react';
import { EditPositionPreferencesSection } from '../edit-position-preferences-section/edit-position-preferences-section.component';
import STRING_KEYS from '../../../../language/keys';
import { EditJobRequirement } from '../../../../modules/application/components/match-tune/edit-job-requirement/edit-job-requirement.component';

export const CompanyBackgroundSection = ({
  companyBackground,
  changeHandler,
}: CompanyBackgroundSectionProps): JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <EditPositionPreferencesSection
      emoji="🎯"
      title={ translate(STRING_KEYS.EDIT_POSITION_PREFERENCES_DIALOG.SECTIONS.COMPANY_BACKGROUND) }
      infoText={ translate(STRING_KEYS.EDIT_POSITION_PREFERENCES_DIALOG.SECTIONS.COMPANY_BACKGROUND_INFO) }
    >
      <EditJobRequirement
        selectedJobRequirements={ companyBackground }
        setSelectedJobRequirementsHandler={ changeHandler }
        enableRequirement
      />
    </EditPositionPreferencesSection>
  );
};
